import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { message } from 'antd'

import { getApiHost } from '../../core-config'
// only 和 once 先别用
interface API {
  instance: AxiosInstance
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig & { source?: any }): Promise<T>
  only: (request: (...params: any[]) => Promise<any>, handle?: (result: Promise<any>) => Promise<any>) => (...params: any[]) => Promise<any>
  once: (request: (...params: any[]) => Promise<any>, handle?: (result: Promise<any>) => Promise<any>) => (...params: any[]) => Promise<any>
}

const cancelMap = new WeakMap<Promise<any>, () => void>()
const prevMap = new Map<(...params: any[]) => Promise<any>, Promise<any>>()
const resultMap = new Map<(...params: any[]) => Promise<any>, Promise<any>>()
const { protocol, host } = window.location
const baseURL: string = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_HOST || getApiHost(host, protocol))
  : `${protocol}//${process.env.WDS_SOCKET_HOST}:${process.env.WDS_SOCKET_PORT}/api`

const api = axios.create({
  baseURL,
  timeout: 0,
  withCredentials: true
})

const exportApi: API = {
  instance: api,
  get: (url, config = {}) => resultHandle(config, () => api.get(url, config)),
  post: (url, data, config = {}) => resultHandle(config, () => api.post(url, data, config)),
  only: (request, handle) => (...params) => {
    const result = request(...params)
    const prevResult = prevMap.get(request)
    const cancel = cancelMap.get(prevResult!)

    cancel && cancel()
    prevMap.set(request, result)
    return handle ? handle(result) : result
  },

  once: (request, handle) => (...params) => {
    const cache = resultMap.get(request)

    if (cache) return cache

    const result = request(...params)

    return result.then(data => {
      handle && handle(result).then(data => {
        const cache = Promise.resolve(data)
        resultMap.set(request, cache)

        return cache
      })

      return Promise.resolve(data)
    })
  }
}

export default exportApi

function resultHandle(config: AxiosRequestConfig & { source?: any }, operate: () => Promise<any>) {
  // 如果传入了source则由外部接管取消动作：调用source.cancel()
  const source = config?.source || axios.CancelToken.source()

  config.cancelToken = source.token

  const result = operate().then(resolveHandle).catch(rejectHandle)

  const cancel = () => {
    source.cancel()
    cancelMap.delete(result)
  }

  cancelMap.set(result, cancel)
  result.finally(cancel)

  return result
}
interface CustomError extends Error {
  rawData?: {
    data: any
    code: number
    msg: string
  }
}

function resolveHandle(res: AxiosResponse<any>) {
  const { data, code, msg } = res.data

  // 等于 44 为无效token
  if(+code === 44)
    return window.location.href = data.url

  // 不等于 0 为系统错误
  if(code !== 0) {
    const err: CustomError = new Error(msg)

    err.rawData = res.data
    return Promise.reject(err)
  }

  return data
}

function rejectHandle(err: Error | string[]) {
  if (err instanceof Error) {
    message.error(err.message || '网络错误!')
    return Promise.reject([err])
  }

  return Promise.reject(err as string[])
}